import { createSlice } from "@reduxjs/toolkit";
import { PROMPTS_PANEL_MODES } from "constants/prompts";
import { extendSliceWithExcelTable } from "slices/excelTable/utils";

export const INITIAL_PROMPT_STATE = {
  prompts: [],
  edits: [],
  users: [],
  isEditing: false,
  promptsPanel: {
    mode: PROMPTS_PANEL_MODES.HIDDEN,
    categoryIndex: -1,
  },
  visiPrompts: [],
  isLockedBy: null,
  lockedByAnotherUser: false,
  selectedRowIndex: 0,
};

const promptEditorSlice = createSlice({
  name: "promptEditor",
  initialState: INITIAL_PROMPT_STATE,
  reducers: {
    loadPromptData(state, { payload }) {
      const { categories, users, isLockedBy, lockedByAnotherUser } =
        payload || {};

      state.prompts = categories;
      state.users = users;
      state.isLockedBy = isLockedBy;
      state.lockedByAnotherUser = lockedByAnotherUser;
    },
    setPromptEditorIsEditing(state) {
      state.isEditing = true;
    },
    setPromptEditorIsNotEditing(state) {
      state.isEditing = false;
    },
    setPromptsPanel(state, { payload }) {
      const { mode = PROMPTS_PANEL_MODES.HIDDEN, categoryIndex = -1 } =
        payload || {};
      state.promptsPanel = {
        mode,
        categoryIndex,
      };
    },
    setPromptEditorViewMode(state) {
      state.isEditing = false;
    },
    setVisiPrompts(state, action) {
      state.visiPrompts = action.payload;
    },
    setSelectedRowIndex: (state, action) => {
      state.selectedRowIndex = action.payload ?? 0;
    },
    ...extendSliceWithExcelTable({
      rootPath: ["prompts"],
    }),
  },
});

export const {
  loadPromptData,
  setPromptEditorIsEditing,
  setPromptEditorIsNotEditing,
  setPromptEditorViewMode,
  setPromptsPanelMode,
  setPromptsPanel,
  setVisiPrompts,
  setSelectedRowIndex,
  updateAllItems,
  removeItemByPath,
  updateItemByPath,
  addCategoryByIndex,
  addChildByPath,
} = promptEditorSlice.actions;

export default promptEditorSlice.reducer;
